export function hasStatusValue(value) {
    return value !== undefined && value !== null && String(value).trim() !== "";
}
export function toStatusSlug(value) {
    return value
        .trim()
        .replace(/[^a-z0-9]+/gi, "-")
        .replace(/^-+|-+$/g, "")
        .toLowerCase();
}
/**
 * Shared id/name status lookup used by entity, lead, and transmission statuses.
 */
export function createIdStatusHelpers(config) {
    const byName = Object.keys(config.byId).reduce((map, id) => {
        map[config.byId[id].label.toLowerCase()] = id;
        return map;
    }, {});
    const emptyMeta = {
        label: "",
        className: "",
    };
    function getMeta(value) {
        if (!hasStatusValue(value)) {
            return emptyMeta;
        }
        const normalized = String(value).trim();
        const status = config.byId[normalized] ||
            config.byId[byName[normalized.toLowerCase()]];
        if (!status) {
            return {
                label: normalized,
                className: config.classPrefix,
            };
        }
        return {
            label: status.label,
            className: `${config.classPrefix} ${config.classPrefix}--${status.slug}`,
        };
    }
    function getOption(flag) {
        const id = String(flag.id);
        const meta = getMeta(id);
        return {
            id,
            name: flag.name || meta.label,
            optionClass: meta.className,
        };
    }
    return { getMeta, getOption };
}
